import PageHeader from "@/components/PageHeader";
import HowItWorksSteps from "@/components/HowItWorksSteps";
import Reveal from "@/components/Reveal";
import EmailCaptureCTA from "@/components/EmailCaptureCTA";
import { Check } from "lucide-react";

const perks = [
  "2-Month Curated Book List, delivered to your inbox",
  "Links to purchase or borrow every read",
  "Themed meetup invites & details",
  "Access to our private online community",
  "Monthly discussion guides & conversation starters",
  "Sisterhood, support & good vibes",
];

export default function HowItWorks() {
  return (
    <div data-testid="how-it-works-page">
      <PageHeader overline="The Experience" title="How It Works" subtitle="From joining the room to gathering in real life — here's how your next chapter unfolds." />

      <section className="py-24 bg-mahogany-900">
        <div className="max-w-7xl mx-auto px-6">
          <HowItWorksSteps />
        </div>
      </section>

      <section className="py-24 bg-cream" data-navbg="light">
        <div className="max-w-5xl mx-auto px-6 grid md:grid-cols-2 gap-14 items-center">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-fuchsia mb-4">Free to Join</p>
            <h2 className="font-serif text-4xl sm:text-5xl font-light text-mahogany-900 mb-4">What You Get</h2>
            <p className="font-script text-3xl text-fuchsia">All of it, on the house.</p>
          </Reveal>
          <Reveal delay={0.1}>
            <ul className="space-y-4">
              {perks.map((p) => (
                <li key={p} className="flex items-start gap-3 text-mahogany-800" data-testid={`perk-${p.slice(0, 8).toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                  <span className="w-6 h-6 rounded-full bg-fuchsia flex items-center justify-center shrink-0 mt-0.5"><Check size={14} className="text-white" /></span>
                  <span className="leading-relaxed">{p}</span>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </section>

      <EmailCaptureCTA />
    </div>
  );
}
